import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  SEARCH_GEO_COUNTRY,
  SEARCH_ARTICLE_GROUP,
  SEARCH_CURRENCY,
  SEARCH_PROJECT,
  SEARCH_ARTICLE_TYPE,
  SEARCH_ARTICLE,
  SEARCH_SUPPLIER,
  SEARCH_ACQUISITION,
  SEARCH_DEMAND
} from '../actions';

import {
  SearchGeoCountrySuccess,
  SearchGeoCountryError,
  SearchArticleGroupSuccess,
  SearchArticleGroupError,
  SearchCurrencySuccess,
  SearchCurrencyError,
  SearchProjectSuccess,
  SearchProjectError,
  SearchArticleTypeSuccess,
  SearchArticleTypeError,
  SearchArticleSuccess,
  SearchArticleError,
  SearchSupplierSuccess,
  SearchSupplierError,
  SearchAcquisitionError,
  SearchAcquisitionSuccess,
  SearchDemandError,
  SearchDemandSuccess
} from '../actions';


export function* watchSearchGeoCountry() {
  yield takeEvery(SEARCH_GEO_COUNTRY, onSearchGeoCountry);
}

export function* watchSearchArticleGroup() {
  yield takeEvery(SEARCH_ARTICLE_GROUP, onSearchArticleGroup);
}

export function* watchSearchCurrency() {
  yield takeEvery(SEARCH_CURRENCY, onSearchCurrency);
}

export function* watchSearchProject() {
  yield takeEvery(SEARCH_PROJECT, onSearchProject);
}

export function* watchSearchArticleType() {
  yield takeEvery(SEARCH_ARTICLE_TYPE, onSearchArticleType);
}

export function* watchSearchArticle() {
  yield takeEvery(SEARCH_ARTICLE, onSearchArticle);
}

export function* watchSearchSupplier() {
  yield takeEvery(SEARCH_SUPPLIER, onSearchSupplier);
}

export function* watchSearchAcquisition() {
  yield takeEvery(SEARCH_ACQUISITION, onSearchAcquisition);
}

export function* watchSearchDemand() {
  yield takeEvery(SEARCH_DEMAND, onSearchDemand);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onSearchGeoCountryAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchArticleGroupAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchCurrencyAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/currency', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchProjectAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/project', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchArticleTypeAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchSupplierAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/supplier', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchAcquisitionAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/acquisition', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchArticleAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/article', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onSearchDemandAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/demand', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onSearchGeoCountry(data) {
  try {
    const response = yield call(onSearchGeoCountryAsync, data);
    yield put(SearchGeoCountrySuccess(response.data));
  } catch (error) {
    yield put(SearchGeoCountryError(error));
  }
}

function* onSearchArticleGroup(data) {
  try {
    const response = yield call(onSearchArticleGroupAsync, data);
    yield put(SearchArticleGroupSuccess(response.data));
  } catch (error) {
    yield put(SearchArticleGroupError(error));
  }
}

function* onSearchCurrency(data) {
  try {
    const response = yield call(onSearchCurrencyAsync, data);
    yield put(SearchCurrencySuccess(response.data));
  } catch (error) {
    yield put(SearchCurrencyError(error));
  }
}

function* onSearchProject(data) {
  try {
    const response = yield call(onSearchProjectAsync, data);
    yield put(SearchProjectSuccess(response.data));
  } catch (error) {
    yield put(SearchProjectError(error));
  }
}

function* onSearchArticleType(data) {
  try {
    const response = yield call(onSearchArticleTypeAsync, data);
    yield put(SearchArticleTypeSuccess(response.data));
  } catch (error) {
    yield put(SearchArticleTypeError(error));
  }
}

function* onSearchArticle(data) {
  try {
    const response = yield call(onSearchArticleAsync, data);
    yield put(SearchArticleSuccess(response.data));
  } catch (error) {
    yield put(SearchArticleError(error));
  }
}

function* onSearchSupplier(data) {
  try {
    const response = yield call(onSearchSupplierAsync, data);
    yield put(SearchSupplierSuccess(response.data));
  } catch (error) {
    yield put(SearchSupplierError(error));
  }
}

function* onSearchAcquisition(data) {
  try {
    const response = yield call(onSearchAcquisitionAsync, data);
    yield put(SearchAcquisitionSuccess(response.data));
  } catch (error) {
    yield put(SearchAcquisitionError(error));
  }
}

function* onSearchDemand(data) {
  try {
    const response = yield call(onSearchDemandAsync, data);
    yield put(SearchDemandSuccess(response.data));
  } catch (error) {
    yield put(SearchDemandError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchSearchGeoCountry),
    fork(watchSearchArticleGroup),
    fork(watchSearchCurrency),
    fork(watchSearchProject),
    fork(watchSearchArticleType),
    fork(watchSearchArticle),
    fork(watchSearchSupplier),
    fork(watchSearchAcquisition),
    fork(watchSearchDemand)
  ]);
}